import React, { useEffect, useState } from "react";
import axios from "axios";
import { ToastsContainer, ToastsContainerPosition, ToastsStore } from "react-toasts";
import { API_URL } from "../../../utils/Common";
import CantidadCicloCurva from "./CantidadCicloCurva";
import MyLoader from "../../sharecomponents/MyLoader";

const initialForm = Object.freeze({
   sem_inicial: "0",
   sem_final: "0",
   propagacion: "0",
   campo: "0",
   sem1: "0",
   sem2: "0",
   sem3: "0",
   sem4: "0",
   sem5: "0",
   sem6: "0",
   sem7: "0",
   sem8: "0",
   sem9: "0",
});

const CiclosCurvaCosecha = (props) => {
   const { florid } = props; // -- ID del TIPO DE FLOR!!!!

   const [ciclosCurva, setCiclosCurva] = useState([]);
   const [form, setForm] = useState(initialForm);
   // -- loader
   const [loader, updateLoader] = useState(false);

   let ciclosSeleccionados = [];

   const handlerChange = (e) => {
      setForm({
         ...form,
         [e.target.name]: e.target.value,
      });
   };

   const getInfo = () => {
      updateLoader(true);
      axios.get(API_URL + "/flor/getCiclosCurva", { params: { florid } }).then((r) => {
         setCiclosCurva(r.data.cicloscurva);
         updateLoader(false);
      });
   };

   useEffect(() => {
      getInfo();
   }, []);

   const onSubmit = (e) => {
      e.preventDefault();
      axios
         .post(API_URL + "/flor/setCiclosCurva", { ...form, florid })
         .then((r) => {
            setForm(initialForm);
            getInfo();
         })
         .catch((e) => console.log(e));
   };

   const handleCheckbox = (e, c) => {
      if (e.target.checked) {
         ciclosSeleccionados.push(c);
      } else {
         let j = ciclosSeleccionados.indexOf(c);
         ciclosSeleccionados.splice(j, 1);
      }
   };

   const eliminarPlanes = () => {
      if (ciclosSeleccionados.length > 0) {
         console.log(ciclosSeleccionados);
         updateLoader(true);
         axios
            .post(API_URL + "/eliminarSemanas", { ciclos: ciclosSeleccionados })
            .then((r) => {
               getInfo();
               updateLoader(false);
               console.log(r.data);
               ToastsStore.success("Semana(s) eliminadas correctamente!");
            })
            .catch((e) => console.log(e));
      } else {
         ToastsStore.error("Selecciona uno mas semanas a Eliminar!");
      }
   };

   return (
      <div className="bg-white shadow-xl overflow-hidden rounded-lg border border-orange-200 p-3 mb-5">
         <h3 className="text-orange-900 font-bold border-b-2 border-orange-700 py-1 pl-1 mb-2">
            Definición de Ciclos y Curva de Cosecha
         </h3>
         {/** Formulario */}
         <form className="mt-5 mb-10" onSubmit={onSubmit}>
            <div className="text-sm flex flex-wrap -mx-3 mb-6">
               <div className="w-1/4 px-3">
                  <label className="block tracking-wide text-gray-700 font-bold mb-2">Semana Inicial:</label>
                  <input
                     className="text-right text-xs appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                     type="number"
                     step="any"
                     name="sem_inicial"
                     value={form.sem_inicial}
                     onChange={handlerChange}
                     onFocus={(e) => e.target.select()}
                  />
               </div>
               <div className="w-1/4 px-3">
                  <label className="block tracking-wide text-gray-700 font-bold mb-2">Semana Final:</label>
                  <input
                     className="text-right text-xs appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                     type="number"
                     step="any"
                     name="sem_final"
                     value={form.sem_final}
                     onChange={handlerChange}
                     onFocus={(e) => e.target.select()}
                  />
               </div>
               <div className="w-1/4 px-3">
                  <label className="block tracking-wide text-gray-700 font-bold mb-2">Ciclo en Propagación:</label>
                  <input
                     className="text-right text-xs appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                     type="number"
                     step="any"
                     name="propagacion"
                     value={form.propagacion}
                     onChange={handlerChange}
                     onFocus={(e) => e.target.select()}
                  />
               </div>
               <div className="w-1/4 px-3">
                  <label className="block tracking-wide text-gray-700 font-bold mb-2">Ciclo en Campo:</label>
                  <input
                     className="text-right text-xs appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                     type="number"
                     step="any"
                     name="campo"
                     value={form.campo}
                     onChange={handlerChange}
                     onFocus={(e) => e.target.select()}
                  />
               </div>
            </div>
            <div className="text-sm flex flex-wrap -mx-3 mb-6">
               <div className="w-1/4 px-3">
                  <label className="block tracking-wide text-gray-700 font-bold mb-2">Semana 1:</label>
                  <input
                     className="text-right text-xs appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                     type="number"
                     step="any"
                     name="sem1"
                     value={form.sem1}
                     onChange={handlerChange}
                     onFocus={(e) => e.target.select()}
                  />
               </div>
               <div className="w-1/4 px-3">
                  <label className="block tracking-wide text-gray-700 font-bold mb-2">Semana 2:</label>
                  <input
                     className="text-right text-xs appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                     type="number"
                     step="any"
                     name="sem2"
                     value={form.sem2}
                     onChange={handlerChange}
                     onFocus={(e) => e.target.select()}
                  />
               </div>
               <div className="w-1/4 px-3">
                  <label className="block tracking-wide text-gray-700 font-bold mb-2">Semana 3:</label>
                  <input
                     className="text-right text-xs appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                     type="number"
                     step="any"
                     name="sem3"
                     value={form.sem3}
                     onChange={handlerChange}
                     onFocus={(e) => e.target.select()}
                  />
               </div>
               <div className="w-1/4 px-3">
                  <label className="block tracking-wide text-gray-700 font-bold mb-2">Semana 4:</label>
                  <input
                     className="text-right text-xs appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                     type="number"
                     step="any"
                     name="sem4"
                     value={form.sem4}
                     onChange={handlerChange}
                     onFocus={(e) => e.target.select()}
                  />
               </div>
            </div>
            <div className="text-sm flex flex-wrap -mx-3 mb-6">
               <div className="w-1/4 px-3">
                  <label className="block tracking-wide text-gray-700 font-bold mb-2">Semana 5:</label>
                  <input
                     className="text-right text-xs appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                     type="number"
                     step="any"
                     name="sem5"
                     value={form.sem5}
                     onChange={handlerChange}
                     onFocus={(e) => e.target.select()}
                  />
               </div>
               <div className="w-1/4 px-3">
                  <label className="block tracking-wide text-gray-700 font-bold mb-2">Semana 6:</label>
                  <input
                     className="text-right text-xs appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                     type="number"
                     step="any"
                     name="sem6"
                     value={form.sem6}
                     onChange={handlerChange}
                     onFocus={(e) => e.target.select()}
                  />
               </div>
               <div className="w-1/4 px-3">
                  <label className="block tracking-wide text-gray-700 font-bold mb-2">Semana 7:</label>
                  <input
                     className="text-right text-xs appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                     type="number"
                     step="any"
                     name="sem7"
                     value={form.sem7}
                     onChange={handlerChange}
                     onFocus={(e) => e.target.select()}
                  />
               </div>
               <div className="w-1/4 px-3">
                  <label className="block tracking-wide text-gray-700 font-bold mb-2">Semana 8:</label>
                  <input
                     className="text-right text-xs appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                     type="number"
                     step="any"
                     name="sem8"
                     value={form.sem8}
                     onChange={handlerChange}
                     onFocus={(e) => e.target.select()}
                  />
               </div>
            </div>
            <div className="text-sm flex flex-wrap -mx-3 mb-6">
               <div className="w-1/4 px-3">
                  <label className="block tracking-wide text-gray-700 font-bold mb-2">Semana 9:</label>
                  <input
                     className="text-right text-xs appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                     type="number"
                     step="any"
                     name="sem9"
                     value={form.sem9}
                     onChange={handlerChange}
                     onFocus={(e) => e.target.select()}
                  />
               </div>
               <div className="w-1/4 px-3">
                  <button
                     className="text-sm bg-orange-800 hover:bg-orange-700 text-white py-2 px-4 rounded shadow focus:outline-none mt-8"
                     type="submit"
                  >
                     Guardar
                  </button>
               </div>
            </div>
         </form>
         {/** ./Formulario */}
         {/** tabla de protocolos */}
         <div className="w-full overflow-x-scroll shadow-xl rounded">
            <button
               className="text-sm bg-orange-800 hover:bg-orange-700 text-white py-1 px-2 mr-5 rounded shadow-lg focus:outline-none"
               onClick={eliminarPlanes}
            >
               <i className="far fa-trash-alt" /> Remover Semanas
            </button>
            <table className="text-xs table-fixed mt-2 mb-2">
               <thead>
                  <tr className="border border-orange-800 text-sm text-white content-center bg-orange-800">
                     <th></th>
                     <th className="w-auto px-1 py-1">Semana</th>
                     <th>Ciclo</th>
                     <th>Ciclo Campo</th>
                     <th className="border border-orange-600 bg-orange-600"></th>
                     <th>Cva Sem 1</th>
                     <th>Cva Sem 2</th>
                     <th>Cva Sem 3</th>
                     <th>Cva Sem 4</th>
                     <th>Cva Sem 5</th>
                     <th>Cva Sem 6</th>
                     <th>Cva Sem 7</th>
                     <th>Cva Sem 8</th>
                     <th>Cva Sem 9</th>
                  </tr>
               </thead>
               <tbody>
                  {ciclosCurva.map((c, i) => {
                     return (
                        <tr key={i} className="text-center">
                           <td className="border px-4 py-2">
                              <div className="flex">
                                 <label className="flex items-center">
                                    <input
                                       key={i}
                                       type="checkbox"
                                       className="form-checkbox"
                                       onChange={(e) => handleCheckbox(e, c)}
                                    />
                                 </label>
                              </div>
                           </td>
                           <td className="border px-4 py-2">{c.semana}</td>
                           <td className="border px-4 py-2">
                              {/*c.propagacion*/}
                              <CantidadCicloCurva cantidad={c.propagacion} cicloId={c.id} campo="propagacion" />
                           </td>
                           <td className="border px-4 py-2">
                              <CantidadCicloCurva cantidad={c.campo} cicloId={c.id} campo="campo" />
                           </td>
                           <td className="border border-orange-600 px-1 py-2 bg-orange-600">{/** SEPARADOR */}</td>
                           <td className="border px-4 py-2">
                              <CantidadCicloCurva cantidad={c.sem1} cicloId={c.id} campo="sem1" />
                           </td>
                           <td className="border px-4 py-2">
                              <CantidadCicloCurva cantidad={c.sem2} cicloId={c.id} campo="sem2" />
                           </td>
                           <td className="border px-4 py-2">
                              <CantidadCicloCurva cantidad={c.sem3} cicloId={c.id} campo="sem3" />
                           </td>
                           <td className="border px-4 py-2">
                              <CantidadCicloCurva cantidad={c.sem4} cicloId={c.id} campo="sem4" />
                           </td>
                           <td className="border px-4 py-2">
                              <CantidadCicloCurva cantidad={c.sem5} cicloId={c.id} campo="sem5" />
                           </td>
                           <td className="border px-4 py-2">
                              <CantidadCicloCurva cantidad={c.sem6} cicloId={c.id} campo="sem6" />
                           </td>
                           <td className="border px-4 py-2">
                              <CantidadCicloCurva cantidad={c.sem7} cicloId={c.id} campo="sem7" />
                           </td>
                           <td className="border px-4 py-2">
                              <CantidadCicloCurva cantidad={c.sem8} cicloId={c.id} campo="sem8" />
                           </td>
                           <td className="border px-4 py-2">
                              <CantidadCicloCurva cantidad={c.sem9} cicloId={c.id} campo="sem9" />
                           </td>
                        </tr>
                     );
                  })}
               </tbody>
            </table>
         </div>
         {/** Toast */}
         <ToastsContainer store={ToastsStore} position={ToastsContainerPosition.TOP_RIGHT} />
         {/** loading **/}
         {loader && <MyLoader />}
      </div>
   );
};

export default CiclosCurvaCosecha;
